import { Layout } from "antd";
import AppRoutes from "../AppRoutes";


function PageContent() {
  return (
    <Layout.Content className="PageContent">
      <AppRoutes />
    </Layout.Content>
  );
}
export default PageContent;
